import React, { useCallback, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Permission from "../../../components/Common/Permission";
import {
  FieldsContainer,
  FieldsSection,
  FlexContainer,
} from "../../../constants/assets/containers";
import Back from "sushiweb/Icons/all/Back";
import Breadcrumb from "sushiweb/Breadcrumb";
import CameraAdd from "sushiweb/Icons/all/CameraAdd";
import VideoTv from "sushiweb/Icons/all/VideoTv";
import PaginatedReactDropdown from "../../../components/Common/PaginatedReactDropdown";
import Input from "sushiweb/InputTypes/Input";
import DateTimePicker from "../../../components/Common/DateTimePicker";
import Button from "sushiweb/Button";
import CrossCircle from "sushiweb/Icons/all/CrossCircle";
import SpinnerCircular from "sushiweb/Spinner/SpinnerCircular";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import variables from "../../../constants/assets/variables";
import * as DriverStoriesActions from "../../../store/actions/DriverStories";

import { isValNull, debounce } from "../../../utils";
import GeographySelectionModal from "../../../components/DriverStories/GeographySelectionModal";
import NoFooterModal from "../../../components/Common/NoFooterModal";
import ImageUploader from "../../../components/Common/ImageUploader";
import VideoUploader from "../../../components/Common/VideoUploader";
import BulkCsvUploadFile from "../../../components/DriverStories/BulkCsvUploadFile/BulkCsvUploadFile";

const storyTypeOptions = [
  { key: "DELIVERY_PARTNER", label: "DP Story" },
  { key: "ZOMATO", label: "Zomato Story" },
  { key: "EXTERNAL_ENTITY", label: "External Story" },
];

const driverSelectionOptions = [
  { key: "GEOGRAPHY", label: "Geography" },
  { key: "CSV", label: "CSV" },
];

const SUPPORTED_VIDEO_FORMAT = [".m3u8", ".mp4"];
const WHATSAPP_SHARE_VIEW_ENABLED = false

const NewStoriesCampaign = (props) => {
  const {
    uploadCampaignImage,
    uploadCampaignVideo,
    driverSelectionCSVUpload,
    resetState,
    createStoryCampaign,
    uploadedImageName,
    getDriverDetails,
    uploadedVideoName,
    activeFilePath,
    getExternalEntitiesList,
  } = props;

  const history = useHistory();
  const allActions = MenuActionsMappings[MenuNames.DRIVER_STORIES];
  const [initialState, setInitialState] = useState({
    requester_type: "ZOMATO",
    requester_id: "",
    external_entity: "", 
    upload_cohort_type: "",
    expiry_time: "",
    media_type: "VIDEO",
    csv_file_s3_key: "",
    csv_data: {},
    image_name: "",
    image_url: "",
    video_url: "",
    video_name: "",
    cdn_video_url: "",
    driver_details: [],
    external_partner_details: [],
    click_to_action: {},
    meta_data: {},
    geography_details: {
      geography_level: "",
      country_id: "",
      state_ids: [],
      city_ids: [],
      locality_city_ids: [],
      state_city_ids: [],
      locality_ids: [],
      driver_service_ids: [],
      active_driver_option: "",
    },
  });
  const [modalState, setModalState] = useState(false);
  const [callback_key, setCallback_key] = useState("");
  const [presign_url, setPresign_url] = useState("");
  const [downloadUrl, setDownloadUrl] = useState("");
  const [formError, setFormError] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [showCtaInputFields, setShowCtaInputFields] = useState(false);
  const [showMetaDataInputFields, setShowMetaDataInputFields] = useState(false);


  let now = new Date();
  let currentDateTime = now.toISOString().slice(0, 16);
  let sevenDaysFromNow = new Date();
  sevenDaysFromNow.setDate(now.getDate() + 7);
  let sevenDaysLater = sevenDaysFromNow.toISOString().slice(0, 16);

  const fetchDriverDetails = useCallback(
    debounce((id) => {
      if (!id.startsWith("FE")) {
        setFormError("Driver ID should start with FE");
        return;
      }
      getDriverDetails(id).then((data) => {
        setInitialState((initialState) => ({
          ...initialState,
          driver_details: data?.drivers?.[0] || [],
        }));
      });
    }, 1000),
    []
  );
  const [externalEntities, setExternalEntities] = useState();

  const getExternalEntitiesListSync = useCallback(
    debounce(async () => {
      try {
        const data = await getExternalEntitiesList({});
        setExternalEntities(data || []);
      } catch (error) {
        console.error("Error fetching external entities list", error);
        setExternalEntities([]);
      }
    }, 1000),
    []
  );

  useEffect(() => {
    getExternalEntitiesListSync();
  }, [getExternalEntitiesListSync]);
  const handleClickToActionInputChange = (key, value) => {
    setInitialState((prevState) => ({
      ...prevState,
      click_to_action: {
        ...prevState.click_to_action,
        [key]: value,
      },
    }));
  };
  const handleMetaDataInputChange = (key, value) => {
    setInitialState((prevState) => ({
      ...prevState,
      meta_data: {
        ...prevState.meta_data,
        [key]: value,
      },
    }));
  };
  

  const handleChange = (key, val, inputEvent = undefined) => {
    setFormError("");
    switch (key) {
      case "upload_cohort_type":
        if (val != "GEOGRAPHY") {
          setInitialState((prevState) => ({
            ...prevState,
            geography_details: {
              geography_level: "",
              country_id: "",
              state_ids: [],
              city_ids: [],
              locality_city_ids: [],
              locality_ids: [],
              driver_service_ids: [],
              active_driver_option: "",
            },
          }));
        }
        setInitialState((prevState) => ({
          ...prevState,
          [key]: val,
        }));
        setModalState(val);
        break;
      case "media_type":
        setInitialState((prevState) => ({
          ...prevState,
          [key]: val,
        }));
        if (typeof inputEvent !== "undefined") {
          const updateState = { ...initialState };
          updateState.cdn_video_url = inputEvent;
          updateState[key] = val;
          setInitialState(updateState);
          setInitialState((prevState) => ({
            ...prevState,
            cdn_video_url: inputEvent,
          }));
          //if input url then don't open modal
          return;
        }
        setModalState(val);
        break;
      case "requester_id":
        setInitialState((prevState) => ({
          ...prevState,
          [key]: val,
        }));
        initialState.requester_type !== "EXTERNAL_ENTITY" && fetchDriverDetails(val);
        break;

      default:
        setInitialState((prevState) => ({
          ...prevState,
          [key]: val,
        }));
    }
  };

  const getInputLabel = (val, options, fromKey, toKey, isNumber) => {
    const activeEle = options.find(
      (item) => item[fromKey] === (isNumber ? parseInt(val) : val)
    );
    return !isValNull(activeEle) ? activeEle[toKey] : "";
  };

  const handleBackClick = () => {
    history.push(`/stories`);
  };

  const handleCreateStory = () => {
    let validatedState = validateDetails();
    if (validatedState === "validated") {
      createStoryCampaign(initialState).then(() => {
        history.push("/stories");
        window.location.reload();
      });
    } else {
      setFormError(validatedState);
    }
  };

  const generateErrorText = (
    fieldLabel,
    trailingText = "field is mandatory"
  ) => {
    return `${fieldLabel} ${trailingText}`;
  };

  const validateGeographyDetails = (details) => {
    const { geography_level } = details;

    switch (geography_level) {
      case "":
        return generateErrorText("Geography level");
        break;
    }
  };

  const validateRequesterType = (err) => {
    if (initialState.requester_type === "DELIVERY_PARTNER") {
      //Driver id doesn't starts with FE
      if (
        initialState.requester_id?.length >= 2 &&
        !initialState.requester_id?.startsWith("FE")
      ) {
        err = "Requester ID should start with FE";
      }
      //Id is length is 0 or driver name is not there
      if (
        initialState.requester_id?.length === 0 ||
        !initialState.driver_details?.name
      ) {
        err = "Invalid Requester ID";
      }
    }
    if (initialState.requester_type === "EXTERNAL_ENTITY" && !initialState.requester_id) {
      err = "Requester ID cannot be empty for External Entity";
    }
    return err;
  };
  const isValidHttpsUrl = (url) => /^https:\/\/\S+$/.test(url);
  const validateDetails = () => {
    let err = "";
    Object.keys(initialState).forEach((key) => {
      if (
        initialState.upload_cohort_type === "GEOGRAPHY" &&
        key === "geography_details"
      ) {
        err = validateGeographyDetails(initialState[key]);
      } else if (
        initialState.upload_cohort_type === "CSV" &&
        key === "csv_file_s3_key"
      ) {
        err = initialState.csv_file_s3_key.length
          ? ""
          : "Please attach CSV file";
      }
      if (isValNull(initialState[key])) {
        switch (key) {
          case "requester_type":
            err = generateErrorText("Story type");
            break;
          case "upload_cohort_type":
            err = generateErrorText("Select viewers");
            break;
        }
      }
    });
    //media url check
    if (
      !(
        initialState.image_url.length ||
        initialState.video_url.length ||
        initialState.cdn_video_url
      )
    ) {
      err = generateErrorText("Atleast one media");
    }
    //cdn url check
    if (initialState.cdn_video_url.length) {
      if (!initialState.cdn_video_url.startsWith("https://"))
        err = "Please enter valid video url";
      if (
        !SUPPORTED_VIDEO_FORMAT.some((format) =>
          initialState.cdn_video_url.endsWith(format)
        )
      )
        err =
          "Please enter valid video url, supported format: " +
          SUPPORTED_VIDEO_FORMAT.join();
    }
    err = validateRequesterType(err);
    if (initialState.requester_type === "EXTERNAL_ENTITY") {
        if (initialState.requester_id == "" || initialState.requester_id == null) {
          err = "Requester ID cannot be empty for External Entity";
        }
        if (initialState.external_entity == "" || initialState.external_entity == null) {
          err = "External Entity cannot be empty";
        }
    }
    if (Object.keys(initialState.click_to_action).length > 0 && Object.keys(initialState.meta_data).length > 0) {
      err = "Please fill either Click to Action or Meta Data fields";
    }
    if (showCtaInputFields) {
      if (!initialState.click_to_action.name || !initialState.click_to_action.link) {
        err = "Click to Action fields (name and link) cannot be empty";
      }
      if (initialState.click_to_action.name && initialState.click_to_action.name.length > 12) {
        err = "CTA Name should be less than or equal to 12 characters";
      }
      if (
        initialState.click_to_action.link &&
        !(initialState.click_to_action.link.includes("driver_app") || isValidHttpsUrl(initialState.click_to_action.link))
      ) {
        err = "CTA Link should contain either 'https' or 'driver_app'";
      }
    }
    if (showMetaDataInputFields) {
      if (!initialState.meta_data.text || !initialState.meta_data.phone_number || !initialState.meta_data.message) {
        err = "Meta Data fields (text, phone number, and message) cannot be empty";
      }
    }
    return err ? err : "validated";
  };

  const handleCloseModal = () => {
    setModalState(false);
  };

  const getSelectionHelperText = () => {
    switch (initialState.upload_cohort_type) {
      case "GEOGRAPHY":
        return (
          <p className="font-10 mb-20 ml-12 text-grey">
            Geography selected
            <br />
          </p>
        );
      case "CSV":
        return (
          <p className="font-10 mb-20 ml-12 text-grey">
            {props.uploadedFileName}
          </p>
        );
    }
  };

  const handleCrossClick = (mediaType) => {
    if (mediaType === "IMAGE") {
      setInitialState({ ...initialState, image_url: "", image_name: "" });
    } else if (mediaType === "VIDEO") {
      setInitialState({ ...initialState, video_url: "", video_name: "" });
    }
  };

  const handleImageChange = (file) => {
    //make api call -> image upload
    const payload = {
      filename: file.name,
    };
    uploadCampaignImage(payload).then((res) => {
      setDownloadUrl(res.download_url);
      setCallback_key(res.callback_key);
      setPresign_url(res.upload_url);
      setIsUploading(true);
    });
  };

  const handleVideoChange = (file) => {
    //make api call -> image upload
    const payload = {
      filename: file.name,
    };
    uploadCampaignVideo(payload).then((res) => {
      setDownloadUrl(res.download_url);
      setCallback_key(res.callback_key);
      setPresign_url(res.upload_url);
      setIsUploading(true);
    });
  };

  const updateDriverSelectionCSVUpload = (fileData) =>
    driverSelectionCSVUpload(fileData).then((data) => {
      setInitialState((prevState) => ({ ...prevState, csv_data: data }));
      return data;
    });

  const handleUrlChange = (mediaType) => {
    if (mediaType === "IMAGE") {
      const values = { ...initialState };
      values.image = downloadUrl;
      values.image_name = uploadedImageName;
      values.image_url = downloadUrl;
      setInitialState((prevState) => ({
        ...prevState,
        video: "",
        video_name: "",
        video_url: "",
        image: downloadUrl,
        image_name: uploadedImageName,
        image_url: downloadUrl,
      }));
    } else if (mediaType === "VIDEO") {
      setInitialState((prevState) => ({
        ...prevState,
        image: "",
        image_name: "",
        image_url: "",
        video: downloadUrl,
        video_name: uploadedVideoName,
        video_url: downloadUrl,
      }));
    }

    // now, resetting the callback key and presign url
    setCallback_key("");
    setPresign_url("");
    setDownloadUrl("");
    setModalState(false);
    setIsUploading(false);
  };

  const getModal = () => {
    switch (modalState) {
      case "GEOGRAPHY":
        return (
          <GeographySelectionModal
            setModalState={setModalState}
            inputFieldState={initialState}
            setInputFieldState={setInitialState}
            getInputLabel={getInputLabel}
            newCampaignOptions={driverSelectionOptions}
          />
        );
      case "CSV":
        return (
          <section>
            <BulkCsvUploadFile
              btnDataTestID="UpdateDriverSelectionCSVUpload"
              sampleURL="/sample/bulk_story_entity_map.csv"
              id="updateDriverSelectionCSVUpload"
              sendExtraAck={true}
              keyName="callback_key"
              heading="Upload CSV file"
              useUserUploadedFilename={true}
              getUploadUrl={updateDriverSelectionCSVUpload}
              customHandleClose={handleCloseModal}
              validationType="DriverStories"
              maxSize={10}
              noAckCall={true}
            />
          </section>
        );
      case "IMAGE":
        return (
          <NoFooterModal
            header={true}
            heading={`Upload Image`}
            handleClose={handleCloseModal}
            id="storiesMediaUploadModal"
          >
            <FlexContainer justify="flex-start">
              <FlexContainer>
                {!(downloadUrl && isUploading) ? (
                  <>
                    <ImageUploader
                      handleImageChange={handleImageChange}
                      id={`imageUpload`}
                      state="Add"
                      imageKey={"thumbnail"}
                      uploadUrl={"/stories/upload_image/ack"}
                      callback_key={callback_key}
                      presign_url={presign_url}
                      keyName="callback_key"
                      maxSize={2}
                      handleImageUrlChange={() => handleUrlChange(modalState)}
                    />
                    <div className="flex mb-26 ml-26 text-grey pill">
                      <ul>
                        <li>Maximum Image Size: 2 MB</li>
                        <li>Supported types: "PNG/JPG/JPEG"</li>
                        <li>Image should be in 9:16 (portrait)</li>
                      </ul>
                    </div>
                  </>
                ) : (
                  <SpinnerCircular
                    size="large"
                    color={variables.grey500}
                    className="justify-between"
                  />
                )}
              </FlexContainer>
            </FlexContainer>
          </NoFooterModal>
        );

      case "VIDEO":
        return (
          <NoFooterModal
            header={true}
            heading={`Upload Video`}
            handleClose={handleCloseModal}
            id="storiesMediaUploadModal"
          >
            <FlexContainer justify="flex-start">
              <FlexContainer>
                {!(downloadUrl && isUploading) ? (
                  <>
                    <VideoUploader
                      handleVideoChange={handleVideoChange}
                      id={`imageUpload`}
                      state="Add"
                      imageKey={"thumbnail"}
                      uploadUrl={"/stories/upload_video/ack"}
                      callback_key={callback_key}
                      presign_url={presign_url}
                      keyName="callback_key"
                      maxSize={20}
                      handleVideoUrlChange={() => handleUrlChange(modalState)}
                      noAckCall
                    />
                    <div className="flex mb-26 ml-26 text-grey pill">
                      <ul>
                        <li>Maximum Image Size: 20 MB</li>
                        <li>Supported types: "MP4/M3U8"</li>
                        <li>Video should be in 9:16 (portrait)</li>
                      </ul>
                    </div>
                  </>
                ) : (
                  <SpinnerCircular
                    size="large"
                    color={variables.grey500}
                    className="justify-between"
                  />
                )}
              </FlexContainer>
            </FlexContainer>
          </NoFooterModal>
        );
      default:
        return;
    }
  };

  const MediaAttachment = ({ mediaType }) => {
    const disabled =
      (mediaType === "IMAGE"
        ? initialState.video_url.length
        : initialState.image_url.length) ||
      isUploading ||
      initialState.cdn_video_url;
    const containerText =
      mediaType === "IMAGE" ? "Upload Image" : "Upload Video";
    const multimediaName =
      mediaType === "IMAGE" ? initialState.image_name : initialState.video_name;
    const icon =
      mediaType === "IMAGE" ? (
        <CameraAdd
          color={disabled ? variables.grey500 : variables.red500}
          size={20}
        />
      ) : (
        <VideoTv
          color={disabled ? variables.grey500 : variables.red500}
          size={20}
        />
      );

    return (
      <React.Fragment>
        <MediaUploadContainer justify="flex-start" disabled={disabled}>
          <UploadMediaBar
            onClick={() => handleChange("media_type", mediaType)}
            disabled={disabled}
          >
            {icon}
            <span>{containerText}</span>
          </UploadMediaBar>
          {multimediaName ? (
            <>
              <FlexContainer>
                <p className="font-10 mb-15 ml-16 text-grey ">
                  {multimediaName}
                </p>
                <CrossCircle
                  onClick={() => handleCrossClick(mediaType)}
                  className="cross"
                  color={variables.red500}
                />
              </FlexContainer>
            </>
          ) : null}
          {downloadUrl &&
          isUploading &&
          initialState.media_type === mediaType ? (
            <SpinnerCircular size="small" color={variables.grey500} />
          ) : null}
        </MediaUploadContainer>
      </React.Fragment>
    );
  };

  useEffect(() => {
    if (activeFilePath) {
      setInitialState((prevState) => ({
        ...prevState,
        csv_file_s3_key: activeFilePath,
      }));
    } else {
      setInitialState((prevState) => ({
        ...prevState,
        driver_selection_type: "",
        csv_file_s3_key: "",
      }));
    }
  }, [activeFilePath]);

  return (
    <Permission requiredParams={[allActions.STORIES_CREATE]}>
      <section>
        <FlexContainer justify="flex-start">
          &emsp;
          <Back
            onClick={handleBackClick}
            className="mr-10 backBtn"
            color={variables.grey400}
          />
          <Breadcrumb className="sushi-breadcrumbs">
            <Breadcrumb.Link onClick={handleBackClick}>Stories</Breadcrumb.Link>
            <Breadcrumb.Link>Create new story</Breadcrumb.Link>
          </Breadcrumb>
        </FlexContainer>
        <FieldsContainer border noPadding className="mt-40">
          <FieldsHolder>
            <FieldsSection marginBottom="1.75rem">
              <p className="section-heading">STORY DETAILS</p>
            </FieldsSection>
            <div>
              <FlexContainer className="justify-start">
                <NamesDiv>
                  <p className="regular ml-5 mb-30">Story Type</p>
                </NamesDiv>
                <InputElements>
                  <PaginatedReactDropdown
                    options={storyTypeOptions}
                    data-testid="storyType"
                    labelKey="label"
                    valueKey="key"
                    labelWidth="8%"
                    keyToChange="requester_type"
                    showCross={false}
                    id="newStoryTypeDropdown"
                    handleChange={handleChange}
                    value={getInputLabel(
                      initialState.requester_type,
                      storyTypeOptions,
                      "key",
                      "label"
                    )}
                    placeholder=""
                  />
                </InputElements>
                </FlexContainer>
              {(initialState.requester_type === "EXTERNAL_ENTITY" )
                &&
                (
                  <FlexContainer>
                <NamesDiv>
                  <p className="regular ml-5 mb-30">External Entity</p>
                </NamesDiv>
                <InputElements>
                  <PaginatedReactDropdown
                    options={externalEntities}
                    data-testid="externalEntity"
                    labelKey="name"
                    valueKey="entityId"
                    labelWidth="8%"
                    keyToChange="external_entity"
                    showCross={false}
                    id="externalEntityDropdown"
                    handleChange={(key, value) => {
                      let entityList = externalEntities
                      setInitialState((prevState) => ({
                        ...prevState,
                        requester_id: value,
                      }));
                      const selectedEntity = entityList.find(
                        (entity) => entity.entityId === value
                      );
                      setInitialState((prevState) => ({
                        ...prevState,
                        external_entity: selectedEntity.name,
                      }));
                    }}
                    value={initialState.external_entity}
                    placeholder=""
                  />
                </InputElements>
                </FlexContainer>
                )}
              {(initialState.requester_type === "DELIVERY_PARTNER" ||
                initialState.requester_type === "EXTERNAL_ENTITY") 
                && 
                (
                <FlexContainer className="justify-start">
                  <NamesDiv>
                    <p className="regular ml-5 mb-30">Requester ID</p>
                  </NamesDiv>
                  <InputElements>
                    <Input
                      value={initialState.requester_id}
                      data-testid="requester_id"
                      id="sushi-input"
                      onChange={(e) => handleChange("requester_id", e)}
                      innerWidth="100%"
                      disabled={initialState.requester_type === "EXTERNAL_ENTITY"}
                    />
                  </InputElements>
                </FlexContainer>
              )}
              {initialState.requester_type !== "EXTERNAL_ENTITY" &&
              (<FlexContainer className="justify-start">
                <NamesDiv>
                  <p className="regular ml-5 mb-30">Requester Name</p>
                </NamesDiv>
                <InputElements>
                  <Input
                    value={
                      initialState.requester_type === "DELIVERY_PARTNER"
                        ? initialState.driver_details?.name
                        : "Zomato"
                    }
                    data-testid="requester_name"
                    id="sushi-input"
                    innerWidth="100%"
                    disabled={true}
                    errorMsg={
                      initialState.driver_details?.length
                        ? "Invalid Driver ID"
                        : ""
                    }
                  />
                </InputElements>
              </FlexContainer>)}
              <FlexContainer className="justify-start">
                <NamesDiv>
                  <p className="regular ml-5 mb-30">Select viewers</p>
                </NamesDiv>
                <InputElements>
                  <PaginatedReactDropdown
                    options={driverSelectionOptions}
                    data-testid="driverSelection"
                    labelKey="label"
                    valueKey="key"
                    keyToChange="upload_cohort_type"
                    placeholder=""
                    showCross={false}
                    id="driverSelectionDropdown"
                    handleChange={handleChange}
                    value={getInputLabel(
                      initialState.upload_cohort_type,
                      driverSelectionOptions,
                      "key",
                      "label"
                    )}
                  />
                  {/* {getSelectionHelperText()} */}
                </InputElements>
              </FlexContainer>
              <FlexContainer className="justify-start">
                <NamesDiv>
                  <p className="regular ml-5 mb-30">Expiry</p>
                </NamesDiv>
                <InputElements>
                  <ExpirySection>
                    <React.Fragment>
                      <div className="datepicker">
                        <DateTimePicker
                          value={initialState.expiry_time}
                          handleChange={(e) =>
                            handleChange("expiry_time", e.target.value)
                          }
                          disableBefore={currentDateTime}
                          disableAfter={sevenDaysLater}
                          placeholder=""
                          id="expiryTime"
                        />
                      </div>

                      <p className="mt-10 mb-20 ml-12 opacity-5 text-grey">
                        Default expiry time in 7 days.
                      </p>
                    </React.Fragment>
                  </ExpirySection>
                </InputElements>
              </FlexContainer>
              <FlexContainer className="justify-start">
                <NamesDiv>
                  <p className="regular ml-5 mb-30">Media</p>
                </NamesDiv>
                <InputElements className="upload">
                  <MediaAttachment mediaType="IMAGE" />
                  <MediaAttachment mediaType="VIDEO" />
                  <p className="mt-10 mb-20 ml-12 opacity-5 text-grey">OR</p>
                  <Input
                    value={initialState.cdn_video_url}
                    onChange={(e) => handleChange("media_type", "VIDEO", e)}
                    id="sushi-input"
                    label="Video link (cdn link with m3u8 and mp4 format only)"
                    disabled={initialState.image_url || initialState.video_url}
                  />
                </InputElements>
              </FlexContainer>
              <FlexContainer className="justify-start">
                <NamesDiv>
                  <p className="regular ml-5 mb-30">Click to Action</p>
                </NamesDiv>
                <InputElements>
                  <input
                    type="checkbox"
                    checked={showCtaInputFields}
                    onChange={() => {
                      setShowCtaInputFields(!showCtaInputFields)
                      setShowMetaDataInputFields(false)
                      setInitialState((prevState) => ({
                      ...prevState,
                      meta_data: {},
                      }));
                    }}
                  />
                </InputElements>
              </FlexContainer>
              {showCtaInputFields && (
                <FlexContainer className="justify-start">
                  <NamesDiv>
                  <p className="regular ml-5 mb-30"> </p>
                </NamesDiv>
                  <InputElements>
                    <Input
                      value={initialState.click_to_action.name || ""}
                      onChange={(e) => handleClickToActionInputChange("name", e)}
                      id="clickToActionName"
                      label="Name"
                    />
                    <Input
                      value={initialState.click_to_action.link || ""}
                      onChange={(e) => handleClickToActionInputChange("link", e)}
                      id="clickToActionLink"
                      label="Link"
                    />
                  </InputElements>
                </FlexContainer>
              )}
              {WHATSAPP_SHARE_VIEW_ENABLED && (
              <FlexContainer className="justify-start">
                <NamesDiv>
                  <p className="regular ml-5 mb-30">Whatsapp Share Data</p>
                </NamesDiv>
                <InputElements>
                  <input
                    type="checkbox"
                    checked={showMetaDataInputFields}
                    onChange={() => {
                      setShowMetaDataInputFields(!showMetaDataInputFields)
                      setShowCtaInputFields(false)
                      setInitialState((prevState) => ({
                        ...prevState,
                        click_to_action: {},
                        }));
                    }}
                  />
                </InputElements>
              </FlexContainer>
              )}
              {showMetaDataInputFields && (
                <FlexContainer className="justify-start">
                <NamesDiv>
                  <p className="regular ml-5 mb-30"> </p>
                </NamesDiv>
                <InputElements>
                <Input
                  value={initialState.meta_data.text || ""}
                  onChange={(e) => handleMetaDataInputChange("text", e)}
                  id="metaDataText"
                  label="Text"
                />
                <Input
                  value={initialState.meta_data.phone_number || ""}
                  onChange={(e) => handleMetaDataInputChange("phone_number", e)}
                  id="metaDataPhoneNumber"
                  label="Phone Number"
                />
                <Input
                  value={initialState.meta_data.message || ""}
                  onChange={(e) => handleMetaDataInputChange("message", e)}
                  id="metaDataMessage"
                  label="Message"
                />
                <Input
                  value={initialState.meta_data.image || ""}
                  onChange={(e) => handleMetaDataInputChange("image", e)}
                  id="metaDataImage"
                  label="Image"
                />
                </InputElements>
                </FlexContainer>
              )}
            </div>
            {formError.length > 0 ? (
              <div className={"error-state"}>{"*" + formError}</div>
            ) : (
              ""
            )}
          </FieldsHolder>
          <FlexContainer justify="flex-end">
            <NextButton>
              <Button
                data-testid="nextButton"
                className="sushi-btn w-25"
                onClick={handleCreateStory}
              >
                Create Story
              </Button>
            </NextButton>
          </FlexContainer>
        </FieldsContainer>
        {modalState && getModal()}
      </section>
    </Permission>
  );
};

const NextButton = styled.div`
  flex: 0 1 65%;
  margin-bottom: 30px;
`;

const FieldsHolder = styled.div`
  padding: 1.875rem;
`;

const NamesDiv = styled.div`
  justify-content: flex-start;
  flex: 0 1 50%;
  p {
    font-family: "OkraRegular", -apple-system, BlinkMacSystemFont, "Segoe UI",
      Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue",
      sans-serif !important;
    letter-spacing: 1.25px;
  }
`;

const ExpirySection = styled.div`
  margin-bottom: 15px;
  padding-bottom: 15px;
  .expiryText {
    flex: 0 1 10%;
    height: 3rem;
    padding: 15px;
    margin-bottom: 15px;
  }
  .datepicker {
    flex: 0 1 50%;
    height: 50px;
    margin-bottom: 15px;
  }
  input {
    width: 98%;
  }
`;

const InputElements = styled.div`
  flex: 0 1 50%;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
  &.upload {
    margin-bottom: 8px;
    div {
      display: flex;
      gap: 6px;
      margin-bottom: 10px;

      p {
        color: ${variables.red500};
      }
    }
  }
`;

const UploadMediaBar = styled(FlexContainer)`
  border: 2px solid
    ${(props) => (props.disabled ? variables.grey500 : variables.red500)};
  border-radius: 20px;
  padding: 3px 8px;
  width: 150px;
  span {
    color: ${(props) =>
      props.disabled ? variables.grey500 : variables.red500};
  }
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;

const MediaUploadContainer = styled(FlexContainer)`
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;

function mapStateToProps(state) {
  const { User } = state;
  return {
    uploadedImageName: User.uploadedImageName,
    uploadedFileName: User.uploadedFileName,
    uploadedVideoName: User.uploadedVideoName,
    activeFilePath: User.activeFilePath,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetState: bindActionCreators(DriverStoriesActions.resetState, dispatch),
    driverSelectionCSVUpload: bindActionCreators(
      DriverStoriesActions.driverSelectionCSVUpload,
      dispatch
    ),
    uploadCampaignImage: bindActionCreators(
      DriverStoriesActions.uploadCampaignImage,
      dispatch
    ),
    uploadCampaignVideo: bindActionCreators(
      DriverStoriesActions.uploadCampaignVideo,
      dispatch
    ),
    createStoryCampaign: bindActionCreators(
      DriverStoriesActions.createStoryCampaign,
      dispatch
    ),
    getDriverDetails: bindActionCreators(
      DriverStoriesActions.getDriverDetails,
      dispatch
    ),
    getExternalEntitiesList: bindActionCreators(
      DriverStoriesActions.getExternalEntitiesList,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewStoriesCampaign);
